import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { ActionType } from './types';
import { GetPermissionsResponse, ConciliationApi } from '../../services';
import { permissionsRequested, permissionsSuccess, permissionsFailure } from './actionCreators';
import { AppPermissions, HttpRequestError } from '../../types';
import { setSingleCountryDashboard } from '../dashboard/actionCreators';

function* getPermissions() {
  yield put(permissionsRequested());
  try {
    const { data }: AxiosResponse<GetPermissionsResponse> = yield call(
      ConciliationApi.getPermissions
    );

    const dashboardAvailablesCountries = data.find(
      permission => permission.permission === AppPermissions.CONCILIATIONS_DASHBOARD
    )?.countries;
    const singleCountryDashboard =
      dashboardAvailablesCountries?.length === 1 &&
      dashboardAvailablesCountries[0].countryAcronym !== 'FULL';
    if (singleCountryDashboard) {
      yield put(setSingleCountryDashboard(dashboardAvailablesCountries[0].countryAcronym));
    }

    yield put(permissionsSuccess(data));
  } catch (error) {
    yield put(permissionsFailure(error as HttpRequestError));
  }
}

export default [takeLatest(ActionType.msalSignInSuccess, getPermissions)];
